module.exports = __webpack_public_path__ + "img/万健.fcf9ba8b.png";